var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronDoubleUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 18.257,
    viewBox: "0 0 22 18.257",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18.257,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_chevron-double-up",
    "data-name": "Icon - chevron-double-up",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-double-up",
    d: "M1.137,87.77l10.4-10.409a.592.592,0,0,1,.838,0l10.4,10.409a.592.592,0,0,1,0,.838l-.35.35a.592.592,0,0,1-.838,0l-9.635-9.64L2.32,88.953a.592.592,0,0,1-.838,0l-.35-.35A.591.591,0,0,1,1.137,87.77Zm0-5.473.35.35a.592.592,0,0,0,.838,0l9.635-9.64,9.64,9.64a.592.592,0,0,0,.838,0l.35-.35a.592.592,0,0,0,0-.838l-10.4-10.409a.592.592,0,0,0-.838,0L1.137,81.458A.592.592,0,0,0,1.137,82.3Z",
    transform: "translate(-0.962 -70.875)",
    fill: "#b2b2b2"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronDoubleUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - chevron-double-up.2a52149d22d8969882b59d1594a6f668.svg";